import { DateTime } from 'luxon'

export const downloadCSVData = (data: string, fileName?: string) => {
  const anchor = document.createElement('a')
  anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
  anchor.target = '_blank'
  anchor.download = formatFileName('csv', fileName)
  anchor.click()
  anchor.remove()
}

export const triggerBrowserDownload = (url: string, fileName: string) => {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  anchor.remove()
}

export const downloadZipData = async (data: string, fileName: string) => {
  const byteCharacters = atob(data)
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'application/zip' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = formatFileName('zip', fileName)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}

function formatFileName(extension: string, fileName?: string): string {
  const time = DateTime.now().toFormat('yyyy-MM-dd--HH-mm-ss')
  return `pbstck-${fileName || 'data'}-${time}.${extension}`
}

/**
 * Open a value as a formatted JSON document in a new tab.
 *
 * A blob rather than a download: a stack's output is read on screen far more often than it is saved, and
 * the CDN-hosted config a One stack links to has no equivalent for the server-side ones — their output
 * lives only in the document.
 */
export const openJsonInNewTab = (data: unknown) => {
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }))
  window.open(url, '_blank')
  // Revoke the URL after the new tab has had time to load the content
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
